<template>
    <p class="powered-section">
 
      {{ $t("Powered by") }} <a
        href="https://plugn.io/?utm_source={{authService.store.name}}&utm_medium=poweredbylink">
        <span class="english">
          Plugn  <ion-icon :icon="openOutline"></ion-icon>
        </span>
      </a>
    </p> 
</template>
<script setup lang="ts">
import { IonIcon } from '@ionic/vue';
import { openOutline } from 'ionicons/icons';
</script>
<style lang="scss" scoped>
.powered-section {
    margin-inline-start: 15px;
    color: #333;

    a {
        color: #3880ff;

        ion-icon {
            position: relative;
            top: 2px;
        }
    }
}
</style>